module.exports = __webpack_public_path__ + "img/uniglobe.a1eb0830.png";